export interface CompanyConfig {
  id: string;
  name: string;
  logo: string;
  hupoLogo: string;
  agentId: string;
  altAgentIds?: string[];
  colors: {
    primary: string;
    primaryDark: string;
    accent: string;
    background: string;
    text: string;
    textSecondary: string;
    border: string;
  };
  landing: {
    headline: string;
    subheadline: string;
    ctaText: string;
    faqs: Array<{
      question: string;
      answer: string;
    }>;
  };
  chat: {
    agentName: string;
    agentTitle: string;
    initialAIMessage: string;
    placeholderQuestions: string[];
  };
}

export const AVAILABLE_COMPANIES = ['cf'] as const;
export type CompanyId = (typeof AVAILABLE_COMPANIES)[number];

export const COMPANY_CONFIGS: Record<CompanyId, CompanyConfig> = {
  cf: {
    id: 'cf',
    name: 'Chocolate Finance',
    logo: '/logos/cf-logo.png',
    hupoLogo: '/logos/Hupo_Logotype_Orange(noR).svg',
    agentId: 'agent_9401k2cavbfke2mby103x5k70g0y', // Gemini 2.5 Flash Lite
    altAgentIds: [
      // Add alternative agent IDs here
      'agent_0201k6jp5kd8e9rbhet695zh1ynd', // Agent with better reasoning model but poor latency (gpt 4.1-mini)
      'agent_7801k7p5y40hf89vatq4rbmd82h6', // Agentic AI, using ElevenLabs built-in features: Workflow (similar to LangGraph), Tests (LLM eval "unit-test" for nodes on the graph), RAG, REST API JSON
      // 'agent_alternative_2',
    ],
    colors: {
      primary: '#C4347C',
      primaryDark: '#6B2244',
      accent: '#E91E9C',
      background: '#FFFFFF',
      text: '#4A2E2A',
      textSecondary: '#6B7280',
      border: '#E5E7EB',
    },
    landing: {
      headline: 'You asked, we answered',
      subheadline: 'Talk to Rich',
      ctaText: 'Start call',
      faqs: [
        {
          question: 'What is Chocolate Finance?',
          answer:
            'Chocolate Finance is a new place for spare cash offering 3% p.a. return on first S$20k, 2.7% p.a. on next S$30k, with daily returns and no lock-ins.',
        },
        {
          question: 'What is the Chocolate Finance USD account?',
          answer:
            'The USD account offers 4.3% p.a. on first US$20k, 4% p.a. on next US$30k, with daily returns and no lock-ins, supporting both USD and SGD accounts.',
        },
        {
          question: 'How do I open a Chocolate Finance account?',
          answer:
            'Download the app, sign up using Singpass MyInfo, verify identity, and add money via bank FAST transfer or PayNow QR.',
        },
        {
          question: "How are Chocolate's returns calculated?",
          answer:
            "Using a compound interest formula that accounts for 'interest on interest', calculating daily, monthly, and annual returns.",
        },
        {
          question: 'How do I add money to my Chocolate Finance account?',
          answer:
            'Transfer money from your bank directly or use PayNow QR. Singapore FAST and PayNow transfers are typically instant.',
        },
        {
          question: 'What are the underlying funds?',
          answer:
            'The portfolio includes funds like Dimensional Short-Term Investment Grade SGD Fund, UOBAM United SGD Fund, and others, invested globally and hedged to SGD.',
        },
        {
          question: 'Is Chocolate Finance safe?',
          answer:
            'Uses Singpass for identity verification, funds safeguarded by MAS-licensed institutions, implements two-factor authentication, and provides real-time alerts.',
        },
      ],
    },
    chat: {
      agentName: 'Rich',
      agentTitle: 'Talk to Rich',
      initialAIMessage:
        "Hi, I'm Rich  - your AI financial advisor. Here anytime you need to talk savings, investments, or anything money. What’s on your mind?",
      placeholderQuestions: [
        'Yeah, is this capital guaranteed?',
        'Hmm, maybe later.',
        "Nah, I'm good. Thanks.",
      ],
    },
  },
};
